export default __webpack_public_path__ + "static/media/microsoft-logo.c6523cdd.svg";